/**
 * Catálogo de apps del bot en el front (labels + extra fields).
 * El contrato técnico vive en el backend; aquí solo la UI.
 * Para agregar ventas: un ítem más en esta lista.
 */
export type BotAppCatalogItem = {
  key: string
  label: string
  description: string
}

export const BOT_APP_CATALOG: BotAppCatalogItem[] = [
  {
    key: "calendar",
    label: "Calendario (agendamiento de citas)",
    description: "El bot podrá agendar, consultar, reprogramar y cancelar citas",
  },
]

export const BOT_APP_LABELS: Record<string, string> = Object.fromEntries(
  BOT_APP_CATALOG.map((app) => [app.key, app.label])
)

export const CALENDAR_APP_KEY = "calendar"

export const hasCalendarApp = (appKeys: string[] | undefined): boolean =>
  Array.isArray(appKeys) && appKeys.includes(CALENDAR_APP_KEY)
